import React from "react";
import SeriesEditPage from "../catalogue/SeriesEditPage";
import {
  deleteSeason,
  getSeasonList,
  getTvShow,
  setShowTrailerMediaId,
  updateShow,
} from "../../../services/shows";
import {
  getTvShowGC,
  uploadShowTrailerMediaId,
} from "../../../store/actions/uploadMediaAction";

const UpdateShow = () => (
  <SeriesEditPage
    idParam="tvshow_id"
    load={getTvShow}
    storeKey="generalContentObjShow"
    setInfo={getTvShowGC}
    pagePath={(id) => `/dashboard/update-show/${id}`}
    category="tv_show"
    genreType="tv shows"
    tagSuffix="-tvshow"
    update={updateShow}
    loadSeasons={getSeasonList}
    deleteSeason={deleteSeason}
    crewUrl="tv-shows"
    infoPath={(id) => `/dashboard/show-info/${id}`}
    episodesPath={(id) => `/dashboard/episode-list/${id}`}
    listPath="/dashboard/show-list"
    trailer={{
      storeKey: "tvShowTrailer",
      link: setShowTrailerMediaId,
      setTrailer: uploadShowTrailerMediaId,
    }}
    texts={{
      title: "Edit Show",
      updated: "Show Info Updated Successfully!",
      seasonError: "Error In Adding Season to TV Show",
    }}
  />
);

export default React.memo(UpdateShow);
